import React, { useState, useEffect, useRef } from "react";
import apiClient from '../ApiClient/ApiClient';
import Dropzone from 'react-dropzone';
import { io } from "socket.io-client";
import axios from 'axios';
import { BlobSource, Input, ALL_FORMATS } from 'mediabunny';

/* CONTENT TYPE */
import vlog from "../assets/video/vlog.mp4";
import unboxing from "../assets/video/unboxing.mp4";
import challenge from "../assets/video/challenge.mp4";
import howTo from "../assets/video/how-to.mp4";
import reaction from "../assets/video/reaction.mp4";
import skit from "../assets/video/skit.mp4";
import storytelling from "../assets/video/storytelling.mp4";
import tutorial from "../assets/video/tutorial.mp4";
import meme from "../assets/video/meme.mp4";
import review from "../assets/video/review.mp4";

/* LIFESTYLE NICHES */
import travel from "../assets/video/travel.mp4";
import fashion from "../assets/video/fashion.mp4";
import beauty from "../assets/video/beauty.mp4";
import cooking from "../assets/video/cooking.mp4";
import fitness from "../assets/video/fitness.mp4";

const contentTypeVideos = [
  { src: vlog, label: "vlog" },
  { src: unboxing, label: "unboxing" },
  { src: challenge, label: "challenge" },
  { src: howTo, label: "how-to" },
  { src: reaction, label: "reaction" },
  { src: skit, label: "skit" },
  { src: storytelling, label: "storytelling" },
  { src: tutorial, label: "tutorial" },
  { src: meme, label: "meme" },
  { src: review, label: "review" },
];

const lifestyleVideos = [
  { src: travel, label: "travel" },
  { src: fashion, label: "fashion" },
  { src: beauty, label: "beauty" },
  { src: cooking, label: "cooking" },
  { src: fitness, label: "fitness" },
];

const listReferenceTemplate = [
  {name: 'content', title: 'Content Type'},
  {name: 'lifestyle', title: 'Lifestyle Niches'},
  {name: 'custom', title: 'Custom Reference'},
]

// Helper function to sort option keys consistently
const sortOptionKeys = (keys) => {
  return [...keys].sort((a, b) => {
    // Extract numbers from option names for proper sorting
    const numA = parseInt(a.replace(/\D/g, '')) || 0;
    const numB = parseInt(b.replace(/\D/g, '')) || 0;
    
    // If both have numbers, sort numerically
    if (numA !== 0 && numB !== 0) {
      return numA - numB;
    }
    
    // If only one has a number, prioritize it
    if (numA !== 0) return -1;
    if (numB !== 0) return 1;
    
    // If neither has numbers, sort alphabetically
    return a.localeCompare(b);
  });
}

// Helper function to generate dynamic listResult from API data
const generateListResult = (terimaHasilGen) => {
  if (!terimaHasilGen || !terimaHasilGen.plans) {
    return [];
  }
  
  // Get all keys from plans object (these are the dynamic option names)
  const optionKeys = Object.keys(terimaHasilGen.plans);
  
  // Sort keys to maintain consistent order
  const sortedKeys = sortOptionKeys(optionKeys);
  
  // Generate listResult with dynamic titles using attribute names
  return sortedKeys.map((key) => {
    // Format the key to be more user-friendly
    // Replace underscores and dashes with spaces, then capitalize first letter of each word
    const formattedTitle = key
      .replace(/[_-]/g, ' ')  // Replace both underscore (_) and dash (-) with space
      .replace(/\b\w/g, (char) => char.toUpperCase());
    
    // Ambil hanya beberapa kata pertama untuk tab (misalnya 2-3 kata pertama)
    const words = formattedTitle.split(' ');
    const shortTitle = words.slice(0, 1).join(' '); // Ambil 2 kata pertama, bisa diubah ke 3 jika perlu
    
    return {
      name: key,
      title: formattedTitle,  // Nama lengkap untuk tooltip dan subtitle
      shortTitle: shortTitle  // Nama pendek untuk tab
    };
  });
}

export default function RightPanel({ ambil, terimaHasilGen, idSession, checkCredit }) {
  /* TAB STATE */
  const [activeTab, setActiveTab] = useState("content");
  const [pilih, setPilih ] = useState("");
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoThumbnail, setVideoThumbnail] = useState(null);

  const [historye, setHistorye] = useState(
    [
      {
        description: "",
        end_time: "",
        reasoning: "",
        resolved_path: "",
        source_index: 0,
        source_name: "",
        start_time: "",
      }
    ]
  )
  const currentVideos =
    activeTab === "content" ? contentTypeVideos : activeTab === "lifestyle" ? lifestyleVideos : [];


  const [activeVideo, setActiveVideo] = useState(contentTypeVideos[0]);
  const [activeVideoThumbnail, setActiveVideoThumbnail] = useState(null);
  const [loading, setLoading] = useState(false)
  const [notification, setNotification] = useState({ show: false, message: '', type: 'success' })
  const [dynamicListResult, setDynamicListResult] = useState([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  
  /* CUSTOM REFERENCE STATE */
  const [customVideoName, setCustomVideoName] = useState('');
  const [quotaCheck, setQuotaCheck] = useState(false);
  const [customVideoFile, setCustomVideoFile] = useState(null);
  const [uploadingLoading, setUploadingLoading] = useState(false);
  const [customReferencesList, setCustomReferencesList] = useState([]);
  const [selectedCustomRef, setSelectedCustomRef] = useState(null);
  const [customRefVideoUrl, setCustomRefVideoUrl] = useState(null);
  const [customRefVideoThumbnail, setCustomRefVideoThumbnail] = useState(null);
  const [deletingRef, setDeletingRef] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null);
  const socketRef = useRef(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  const [customVideoNameFix, setCustomVideoNameFix] = useState("");

  // Fungsi untuk generate thumbnail dari video URL
  const generateThumbnailFromUrl = (videoUrl) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      
      video.src = videoUrl;
      video.muted = true; // iOS often blocks autoplay/loading if not muted
      video.playsInline = true; // Crucial for background loading on iOS
      video.crossOrigin = "anonymous";
      video.currentTime = 0.1; // Seek to the first frame

      const captureFrame = () => {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          
          // Set the generated image as thumbnail
          const thumbnail = canvas.toDataURL("image/jpeg");
          
          // Cleanup
          video.remove();
          canvas.remove();
          
          resolve(thumbnail);
        } catch (error) {
          console.error('Error generating thumbnail:', error);
          // Cleanup on error
          video.remove();
          canvas.remove();
          resolve(null);
        }
      };

      const handleError = () => {
        console.error('Error loading video for thumbnail');
        video.remove();
        canvas.remove();
        resolve(null);
      };

      // Wait for the seek to complete before capturing
      video.addEventListener("seeked", captureFrame, { once: true });
      video.addEventListener("error", handleError, { once: true });
      
      // Trigger the load
      video.load();
    });
  };

  // Generate thumbnail ketika activeVideo berubah
  useEffect(() => {
    if (activeVideo && activeVideo.src && !terimaHasilGen && activeTab !== 'custom' && idSession === "") {
      generateThumbnailFromUrl(activeVideo.src).then((thumbnail) => {
        setActiveVideoThumbnail(thumbnail);
      });
    } else {
      setActiveVideoThumbnail(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeVideo, terimaHasilGen, activeTab, idSession]);

  // Generate thumbnail untuk custom reference video
  useEffect(() => {
    if (customRefVideoUrl) {
      generateThumbnailFromUrl(customRefVideoUrl).then((thumbnail) => {
        setCustomRefVideoThumbnail(thumbnail);
      });
    } else {
      setCustomRefVideoThumbnail(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customRefVideoUrl]);

  // Generate thumbnail untuk video hasil generate (videoUrl)
  useEffect(() => {
    if (videoUrl && terimaHasilGen && idSession !== "") {
      generateThumbnailFromUrl(videoUrl).then((thumbnail) => {
        setVideoThumbnail(thumbnail);
      });
    } else {
      setVideoThumbnail(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoUrl, terimaHasilGen, idSession]);

  /* GENERATE DYNAMIC LIST RESULT DARI API */
  useEffect(() => {
    if (terimaHasilGen && terimaHasilGen.plans) {
      const dynamicList = generateListResult(terimaHasilGen);
      setDynamicListResult(dynamicList);
      
      // Set active tab ke option pertama jika belum ada yang dipilih atau activeTab bukan salah satu dari dynamic options
      if (dynamicList.length > 0) {
        const currentOptionExists = dynamicList.some(item => item.name === activeTab);
        if (!currentOptionExists) {
          setActiveTab(dynamicList[0].name);
        }
      }
    } else {
      setDynamicListResult([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [terimaHasilGen]);

  /* RESET VIDEO SAAT TAB BERUBAH */
  useEffect(() => {
    if(!terimaHasilGen) {
      if (activeTab === 'content') {
        setActiveVideo(contentTypeVideos[0]);
      } else if (activeTab === 'lifestyle') {
        setActiveVideo(lifestyleVideos[0]);
      } else if (activeTab === 'custom') {
        // Panggil API references saat tab custom dipilih
        getReferences();
      }
      setVideoUrl(null);
      setVideoThumbnail(null);
    }else{
      // Gunakan dynamic access berdasarkan activeTab
      if (terimaHasilGen.plans && terimaHasilGen.plans[activeTab]) {
        const planData = terimaHasilGen.plans[activeTab];
        const videoPath = terimaHasilGen.videos && terimaHasilGen.videos[activeTab] 
          ? terimaHasilGen.videos[activeTab] 
          : null;
        
        if (planData && Array.isArray(planData) && planData.length > 0) {
          setHistorye(planData);
        }
        
        if (videoPath) {
          getVideo(videoPath);
        }
      }
    }
  }, [activeTab, terimaHasilGen]);

  useEffect(() => {
    ambil(pilih)
  }, [pilih])

  // Auto-hide notification after 3 seconds
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setNotification({ show: false, message: '', type: 'success' });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [notification.show])

  useEffect(() => {
    if(terimaHasilGen){
      console.log(terimaHasilGen)
      if(terimaHasilGen.videos && terimaHasilGen.plans) {
        // Get first available option key using same sorting logic as generateListResult
        const optionKeys = Object.keys(terimaHasilGen.plans);
        const sortedKeys = sortOptionKeys(optionKeys);
        const firstOptionKey = sortedKeys[0];
        
        if (firstOptionKey) {
          setActiveTab(firstOptionKey);
          
          if(idSession == "") {
            setVideoUrl(null);
            setVideoThumbnail(null);
            setLoading(false)
          } else {
            const firstVideoPath = terimaHasilGen.videos[firstOptionKey];
            if (firstVideoPath) {
              getVideo(firstVideoPath);
            }
          }
        }
      }
      
      // Set history untuk option pertama yang tersedia
      if(terimaHasilGen.plans) {
        const optionKeys = Object.keys(terimaHasilGen.plans);
        const sortedKeys = sortOptionKeys(optionKeys);
        const firstOptionKey = sortedKeys[0];
        
        if (firstOptionKey && terimaHasilGen.plans[firstOptionKey]) {
          const firstPlan = terimaHasilGen.plans[firstOptionKey];
          if(Array.isArray(firstPlan) && firstPlan.length > 0){
            setHistorye(firstPlan);
          }
        }
      }
      
    } else {
      // Reset tab ke Content Type ketika terimaHasilGen menjadi null
      setActiveTab("content");
      setPilih("");
      setVideoUrl(null);
      setVideoThumbnail(null);
      setActiveVideo(contentTypeVideos[0]);
      setDynamicListResult([]);
    }
  }, [terimaHasilGen]);

  // Cleanup socket on unmount or tab change
  useEffect(() => {
    return () => {
      if (socketRef.current) {
        console.log('🔌 Cleaning up socket connection');
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [activeTab])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen])

  const getVideo = async (link) => {
    setLoading(true)

    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/video/generate/gcs?path=${link}`,
        // responseType: 'blob',
    };

    try {
        const response = await apiClient.request(config);
        console.log(response.data);
        // const videoBlob = new Blob([response.data], { type: 'application/octet-stream' });
        // const videoUrl = URL.createObjectURL(videoBlob);
        // // console.log(videoUrl)
        
        if(idSession == "") {
          setVideoUrl(null);
          setVideoThumbnail(null);
          setLoading(false);
        } else {
          if (response.data && response.data.video) {

            setVideoUrl(response.data.video);
            // setVideoThumbnail(response.data.thumbnail);
            setLoading(false);
          }
        }
    } catch (error) {
        console.log(error);
        setLoading(false);
    }
  }

  const getReferences = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/references?custom_only=true`,
    };

    apiClient.request(config)
    .then((response) => {
        // console.log('References API Response:', JSON.stringify(response.data, null, 2));
        // console.log('References Data:', response.data);
        
        // Extract data array from response
        if (response.data?.data && Array.isArray(response.data.data)) {
          setCustomReferencesList(response.data.data);
        } else if (Array.isArray(response.data)) {
          setCustomReferencesList(response.data);
        }
        
        return response.data;
    })
    .catch((error) => {
        console.log('References API Error:', error);
        if (error.response) {
            console.log('Error Response Data:', error.response.data);
            console.log('Error Response Status:', error.response.status);
            console.log('Error Response Headers:', error.response.headers);
        } else if (error.request) {
            console.log('Error Request:', error.request);
        } else {
            console.log('Error Message:', error.message);
        }
    });
  }

  const getCustomRefVideo = (refName) => {
    setLoading(true);
    setSelectedCustomRef(refName);
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/references/video?tag=${refName}`,

    };

    apiClient.request(config)
    .then((response) => {
        // const videoBlob = new Blob([response.data], { type: 'video/mp4' });
        // const videoUrl = URL.createObjectURL(videoBlob);
        // setCustomRefVideoUrl(videoUrl);
        console.log(response.data);
        const videoUrl = response.data.reference_link;
        setCustomRefVideoUrl(videoUrl);
        setLoading(false);
    })
    .catch((error) => {
        console.log('Error loading custom reference video:', error);
        setLoading(false);
    });
  }

  const setupSocketForUpload = (processSession) => {
    // Disconnect existing socket if any
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
    }

    // Create new socket connection
    const urlSocketIO = `${process.env.REACT_APP_WSS_URL}?session_id=${processSession}`;
    const socket = io(urlSocketIO, {
      transports: ["websocket"]
    });

    console.log(`🔌 Setting up socket for custom reference upload [${processSession}]`);

    // Set up event listeners
    socket.on('video_generate_status', (data) => {
      console.log(`🎥 Update status custom reference upload [${processSession}]:`, data);
      
      // Show progress UI
      setShowProgress(true);
      
      if (data.percentage !== undefined) {
        setUploadProgress(data.percentage);
      }
      
      if (data.status !== undefined) {
        setUploadStatus(data.status);
      }

      if(data.percentage == 100) {
        console.log(`✅ Custom reference upload completed [${processSession}]`);
        checkCredit();
        
        // Wait 2 seconds before hiding progress with smooth animation
        setTimeout(() => {
          setShowProgress(false);

          
          // Small delay before clearing states for smooth transition
          setTimeout(() => {
            setUploadProgress(0);
            setUploadStatus(null);
            
            // Refresh custom references list
            getReferences();
            
            // Disconnect socket when done
            if (socketRef.current) {
              socketRef.current.disconnect();
              socketRef.current = null;
            }
          }, 300); // 300ms for fade out animation
        }, 2000); // 2 seconds delay as requested
      }
    });

    socket.on('video_generate_data', (data) => {
      console.log(`📦 Update data custom reference upload [${processSession}]:`, data);
      setUploadingLoading(false);
    });

    socket.on('connect', () => {
      console.log(`✅ Socket connected for custom reference upload: ${processSession}`);
    });

    socket.on('disconnect', () => {
      console.log(`❌ Socket disconnected for custom reference upload: ${processSession}`);
    });

    socket.on('error', (error) => {
      console.error(`❌ Socket error for custom reference upload ${processSession}:`, error);
    });

    // Store socket in ref
    socketRef.current = socket;
    return socket;
  }

  const deleteCustomReference = (refName) => {
    // Generate random number 8 digit untuk process_session
    const randomNumber = Math.floor(10000000 + Math.random() * 90000000);
    // console.log('Delete Custom Reference - process_session:', randomNumber);
    
    setDeletingRef(refName);
    setShowDeleteConfirm(null);

    let data = new FormData();
    let config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/references?tag=${refName}&process_session=${randomNumber}`,
        data: data
    };

    // console.log('Delete Custom Reference - Request Config:', {
    //   method: config.method,
    //   url: config.url,
    //   refName: refName,
    //   process_session: randomNumber
    // });

    apiClient.request(config)
    .then((response) => {
        // console.log('Delete Custom Reference - Success Response:');
        // console.log('Response Status:', response.status);
        // console.log('Response Data (JSON):', JSON.stringify(response.data, null, 2));
        // console.log('Response Data (Object):', response.data);
        
        setDeletingRef(null);
        
        // Clear video if deleted reference was selected
        if (selectedCustomRef === refName) {
          setSelectedCustomRef(null);
          setCustomRefVideoUrl(null);
        }
        
        // Refresh custom references list
        setTimeout(() => {
          getReferences();

          setNotification({ 
            show: true, 
            message: `Custom reference "${refName.replace(/_/g, ' ')}" deleted successfully!`, 
            type: 'success' 
          });
        }, 3000)
        
        return response.data;
    })
    .catch((error) => {
        console.log('Delete Custom Reference - Error:');
        console.log('Error Object:', error);
        
        setDeletingRef(null);
        
        if (error.response) {
            console.log('Error Response Status:', error.response.status);
            console.log('Error Response Data:', error.response.data);
            console.log('Error Response Data (JSON):', JSON.stringify(error.response.data, null, 2));
            
            setNotification({ 
              show: true, 
              message: `Delete failed: ${error.response.data?.message || error.response.statusText || 'Unknown error'}`, 
              type: 'error' 
            });
        } else if (error.request) {
            console.log('Error Request:', error.request);
            
            setNotification({ 
              show: true, 
              message: 'Delete failed: No response from server', 
              type: 'error' 
            });
        } else {
            console.log('Error Message:', error.message);
            
            setNotification({ 
              show: true, 
              message: `Delete failed: ${error.message}`, 
              type: 'error' 
            });
        }
    });
  }

  const getContentType = (fileType) => {
    if (fileType.includes('mp4')) {
      return 'video/mp4';
    } else if (fileType.includes('mov') || fileType.includes('quicktime')) {
      return 'video/quicktime';
    } else if (fileType.includes('webm')) {
      return 'video/webm';
    }
    // Default fallback
    return 'video/mp4';
  };

  // Fungsi untuk mendapatkan durasi video
  async function getVideoDuration(file) {
    try {
      const input = new Input({
        formats: ALL_FORMATS,
        source: new BlobSource(file),
      });

      const duration = await input.computeDuration();
      return isFinite(duration) ? Math.floor(duration) : 0;
    } catch (error) {
      console.error('Error getting video duration with MediaBunny:', error);
      return 0;
    }
  }

  const uploadCustomReference = () => {
    // Validasi: nama video tidak boleh pakai spasi
    if (customVideoName.includes(' ')) {
      console.log('Error: Video name cannot contain spaces');
      setNotification({ 
        show: true, 
        message: 'Video name cannot contain spaces. Please use underscores or hyphens instead.', 
        type: 'error' 
      });
      return;
    }

    // Validasi: file dan nama harus ada
    if (!customVideoFile || !customVideoName) {
      console.log('Error: Video file and name are required');
      setNotification({ 
        show: true, 
        message: 'Please upload a video file and enter a video name.', 
        type: 'error' 
      });
      return;
    }

    // Set loading state
    setUploadingLoading(true);
    setNotification({ show: false, message: '', type: 'success' });
    setUploadProgress(0);
    setUploadStatus(null);
    setShowProgress(false);

    // Generate random number 8 digit untuk process_session
    const randomNumber = Math.floor(10000000 + Math.random() * 90000000);
    // console.log('Generated process_session:', randomNumber);

    let dataUpload = new FormData();
    dataUpload.append('filename', customVideoFile.name);
    dataUpload.append('process_session', randomNumber);

    let configUpload = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/references/gcs/upload`,
        data : dataUpload
    };

    apiClient.request(configUpload)
      .then( async (response) => {
          console.log(response.data.upload_url);

          // Upload video to GCS
          const uploadUrl = response.data.upload_url;
          const contentType = getContentType(customVideoFile.type);
          let config2 = {
            method: 'put',
            maxBodyLength: Infinity,
            url: uploadUrl,
            headers: {
              'Content-Type': contentType
            },
            data: customVideoFile // Binary file data
          };
    
          const response2 = await axios.request(config2);
          console.log(response2);
          setupSocketForUpload(randomNumber.toString());

          // Jika upload ke GCS berhasil, lanjutkan ke API references/gcs
          if (response2.status >= 200 && response2.status < 300) {
            // Get video duration
            const videoDuration = await getVideoDuration(customVideoFile);
            
            // Panggil API references/gcs
            let data = new FormData();
            data.append('filename', customVideoNameFix);
            data.append('tag', customVideoName);
            data.append('process_session', randomNumber.toString());
            data.append('quota_check', false);
            data.append('duration', videoDuration);

            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: `${process.env.REACT_APP_API_URL}/references/gcs`,
              data: data
            };

            apiClient.request(config)
              .then((response) => {
                setUploadingLoading(false);
                
                // Build success message  
                if (quotaCheck && response.data?.data?.credit_used !== undefined) {
                  const creditUsed = Math.floor(response.data.data.credit_used);
                  let successMessage = `Your estimated quota consumption is ${creditUsed}.`;
                  setNotification({ 
                    show: true, 
                    message: successMessage, 
                    type: 'success' 
                  });
                }
                checkCredit();
                
                // Setup socket.io connection to monitor upload progress
                // setupSocketForUpload(randomNumber.toString());
                
                // Refresh custom references list
                // setTimeout(() => {
                //   getReferences();
                // }, 3000);
                
                return response.data;
              })
              .catch((error) => {
                console.log('Error calling references/gcs:', error);
                setUploadingLoading(false);
                setShowProgress(false);
                setUploadProgress(0);
                setUploadStatus(null);
                setNotification({ 
                  show: true, 
                  message: `Upload failed: ${error.response?.data?.message || error.message || 'Unknown error'}`, 
                  type: 'error' 
                });
              });
          }

      })
      .catch((error) => {
          console.log('Error uploading to GCS:', error);
          setUploadingLoading(false);
          setShowProgress(false);
          setUploadProgress(0);
          setUploadStatus(null);
          setNotification({ 
            show: true, 
            message: `Upload failed: ${error.response?.data?.message || error.message || 'Unknown error'}`, 
            type: 'error' 
          });
      });

    // Buat FormData
    // let data = new FormData();
    // data.append('video', customVideoFile);
    // data.append('tag', customVideoName);
    // data.append('process_session', randomNumber.toString());
    // data.append('quota_check', quotaCheck.toString());

    // console.log('Upload Custom Reference - FormData:');
    // console.log('- video:', customVideoFile.name, customVideoFile);
    // console.log('- tag:', customVideoName);
    // console.log('- process_session:', randomNumber);
    // console.log('- quota_check:', quotaCheck);

    // let config = {
    //     method: 'post',
    //     maxBodyLength: Infinity,
    //     url: `${process.env.REACT_APP_API_URL}/references`,
    //     data: data
    // };

    // console.log('Upload Custom Reference - Request Config:', {
    //   method: config.method,
    //   url: config.url,
    // });

    // apiClient.request(config)
    // .then((response) => {
    //     // console.log('Upload Custom Reference - Success Response:');
    //     // console.log('Response Status:', response.status);
    //     // console.log('Response Headers:', response.headers);
    //     // console.log('Response Data (JSON):', JSON.stringify(response.data, null, 2));
    //     // console.log('Response Data (Object):', response.data);
        
    //     setUploadingLoading(false);
        
    //     // Build success message  
        
    //     if (quotaCheck && response.data?.data?.credit_used !== undefined) {
    //       const creditUsed = Math.floor(response.data.data.credit_used);
    //       let successMessage = `Your estimated quota consumption is ${creditUsed}.`;
    //       setNotification({ 
    //         show: true, 
    //         message: successMessage, 
    //         type: 'success' 
    //       });
    //     }
    //     checkCredit();
        
    //     // Setup socket.io connection to monitor upload progress
    //     setupSocketForUpload(randomNumber.toString());
        
    //     // Refresh custom references list
    //     setTimeout(() => {
    //       getReferences();
    //     }, 3000)
        

        
    //     return response.data;
    // })
    // .catch((error) => {
    //     console.log('Upload Custom Reference - Error:');
    //     console.log('Error Object:', error);
        
    //     setUploadingLoading(false);
    //     setShowProgress(false);
    //     setUploadProgress(0);
    //     setUploadStatus(null);
        
    //     if (error.response) {
    //         console.log('Error Response Status:', error.response.status);
    //         console.log('Error Response Data:', error.response.data);
    //         console.log('Error Response Data (JSON):', JSON.stringify(error.response.data, null, 2));
    //         console.log('Error Response Headers:', error.response.headers);
            
    //         setNotification({ 
    //           show: true, 
    //           message: `Upload failed: ${error.response.data?.message || error.response.statusText || 'Unknown error'}`, 
    //           type: 'error' 
    //         });
    //     } else if (error.request) {
    //         console.log('Error Request:', error.request);
    //         console.log('No response received from server');
            
    //         setNotification({ 
    //           show: true, 
    //           message: 'Upload failed: No response from server', 
    //           type: 'error' 
    //         });
    //     } else {
    //         console.log('Error Message:', error.message);
    //         console.log('Error Config:', error.config);
            
    //         setNotification({ 
    //           show: true, 
    //           message: `Upload failed: ${error.message}`, 
    //           type: 'error' 
    //         });
    //     }
    // });
  }

  const AnimatedDots = () => {
      const [dots, setDots] = useState('');

      useEffect(() => {
          const intervals = ['', '.', '..', '...', '....', '.....', '..... 👻', '..... 👻✨'];
          let i = 0;

          const interval = setInterval(() => {
          setDots(intervals[i]);
          i = (i + 1) % intervals.length;
          }, 400); // ubah tiap 300ms

          return () => clearInterval(interval);
      }, []);

      return <span>{dots}</span>;
  };

  const UploadLoadingSpinner = () => {
    return (
      <div className="flex items-center gap-3">
        <div className="relative">
          <svg 
            className="animate-spin h-5 w-5 text-white" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24"
          >
            <circle 
              className="opacity-25" 
              cx="12" 
              cy="12" 
              r="10" 
              stroke="currentColor" 
              strokeWidth="4"
            ></circle>
            <path 
              className="opacity-75" 
              fill="currentColor" 
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <div className="absolute inset-0 animate-ping">
            <div className="h-5 w-5 rounded-full bg-[#00FFD1] opacity-20"></div>
          </div>
        </div>
        <span className="font-medium animate-pulse flex items-center gap-1">
          <span>Uploading</span>
          <span className="inline-flex gap-0.5">
            <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
          </span>
        </span>
      </div>
    );
  };

  const handleDownload = async () => {
    if (!videoUrl) return;

    // Ambil title dari tab aktif untuk nama file
    const activeItem = dynamicListResult.find(item => item.name === activeTab);
    let fileName = "video-generate"; // Default fallback
    
    if (activeItem && activeItem.title) {
      // Bersihkan nama file dari karakter yang tidak valid untuk nama file
      // Ganti spasi dan karakter khusus dengan underscore, hapus karakter yang tidak diizinkan
      fileName = activeItem.title
        .replace(/[<>:"/\\|?*]/g, '') // Hapus karakter khusus yang tidak diizinkan
        .replace(/\s+/g, '_') // Ganti spasi dengan underscore
        .replace(/_{2,}/g, '_') // Hapus multiple underscore
        .trim()
        .toLowerCase();
      
      // Pastikan nama file tidak kosong
      if (!fileName) {
        fileName = "video-generate";
      }
    }

    try {
      let downloadUrl = videoUrl;
      let shouldRevoke = false;

      // Cek apakah videoUrl adalah URL eksternal (http/https)
      if (videoUrl.startsWith('http://') || videoUrl.startsWith('https://')) {
        // Fetch video sebagai blob untuk URL eksternal
        const response = await fetch(videoUrl);
        if (!response.ok) {
          throw new Error('Failed to fetch video');
        }
        const blob = await response.blob();
        downloadUrl = URL.createObjectURL(blob);
        shouldRevoke = true;
      }

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `${fileName}.mp4`; // Tambahkan extension .mp4
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Hanya revoke jika kita membuat object URL baru
      if (shouldRevoke) {
        URL.revokeObjectURL(downloadUrl);
      } else if (videoUrl.startsWith('blob:')) {
        // Jika videoUrl adalah blob URL yang sudah ada, jangan revoke karena mungkin masih digunakan
        // URL.revokeObjectURL(videoUrl); 
      }
    } catch (error) {
      console.error('Error downloading video:', error);
      // Fallback: coba download langsung dengan link
      const link = document.createElement('a');
      link.href = videoUrl;
      link.download = `${fileName}.mp4`;
      link.target = '_blank'; // Fallback: buka di tab baru jika fetch gagal
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const videoRef = useRef(null);
  const goToSecond = (s) => {
    const [minutes, seconds] = s.split(':').map(Number);
    const waktu = minutes * 60 + seconds;

    if (videoRef.current) {
      videoRef.current.scrollIntoView({
        behavior: 'smooth', // animasi smooth
        block: 'center'     // opsional: posisikan di tengah layar
      });
      videoRef.current.currentTime = waktu; // misal: 2 detik
      setTimeout(() => {
        videoRef.current.play();
      },1000) // opsional: langsung play
    }
  };

  const copyTableToClipboard = () => {
    if (!historye || historye.length === 0) return;

    // Header row
    const headers = ['No', 'Start', 'End', 'Reasoning'];
    
    // Convert data to TSV format (Tab-Separated Values) for Excel
    const rows = historye.map((clip, index) => {
      return [
        index + 1,
        clip.target_start_time || '',
        clip.target_end_time || '',
        clip.description || ''
      ].join('\t');
    });

    // Combine headers and rows
    const tsvContent = [headers.join('\t'), ...rows].join('\n');

    // Copy to clipboard with fallback for older browsers
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Modern Clipboard API
      navigator.clipboard.writeText(tsvContent).then(() => {
        setNotification({ 
          show: true, 
          message: 'Table data successfully copied to clipboard! Paste into Excel to see the results.', 
          type: 'success' 
        });
      }).catch(err => {
        console.error('Failed to copy to clipboard:', err);
        // Fallback to old method
        fallbackCopyToClipboard(tsvContent);
      });
    } else {
      // Fallback for browsers without Clipboard API
      fallbackCopyToClipboard(tsvContent);
    }
  };

  const fallbackCopyToClipboard = (text) => {
    // Create a temporary textarea element
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        setNotification({ 
          show: true, 
          message: 'Table data successfully copied to clipboard! Paste into Excel to see the results.', 
          type: 'success' 
        });
      } else {
        setNotification({ 
          show: true, 
          message: 'Failed to copy data to clipboard. Please copy manually.', 
          type: 'error' 
        });
      }
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      setNotification({ 
        show: true, 
        message: 'Failed to copy data to clipboard. Please copy manually.', 
        type: 'error' 
      });
    } finally {
      document.body.removeChild(textArea);
    }
  };

  return (
    <div
      className="
        flex-1 rounded-3xl p-8 md:mx-6 space-y-6
        border border-white/10 backdrop-blur-xl
        shadow-[0_10px_40px_rgba(0,0,0,0.35)]
      "
      style={{
        background:
          "linear-gradient(180deg, rgba(53,53,53,0.55) 0%, rgba(196,196,196,0.08) 100%)",
      }}
    >

      {/* TOP TAB */}
      <span className="inline-block text-[12px] font-medium text-white bg-[#044250] px-3 py-1 rounded-full">
        {terimaHasilGen && idSession != "" ? "Result" : "Reference Template"}
      </span>

      {/* MAIN VIDEO PREVIEW */}
      <div className="bg-black/20 rounded-2xl p-6 flex flex-col items-center border border-white/10 backdrop-blur shadow-inner space-y-10">
        {/* TABS / DROPDOWN */}
        <div className="space-y-3">
          {terimaHasilGen && idSession != "" ? (
            <div className="relative" ref={dropdownRef}>
              {/* Dropdown Button */}
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className={`
                  group
                  relative
                  w-full
                  px-3 md:px-4 
                  py-2 md:py-2.5 
                  rounded-lg 
                  font-medium 
                  text-left
                  text-xs md:text-sm
                  transition-all 
                  duration-300
                  overflow-hidden
                  touch-manipulation
                  select-none
                  focus-visible:outline-none
                  focus-visible:ring-2
                  focus-visible:ring-[#00FFD1]/50
                  focus-visible:ring-offset-2
                  focus-visible:ring-offset-transparent
                  bg-gradient-to-r from-[#00FFD1]/20 via-[#00FFD1]/15 to-[#00FFD1]/20 
                  text-white 
                  border border-[#00FFD1]/40 
                  shadow-lg shadow-[#00FFD1]/10
                  hover:shadow-[#00FFD1]/20
                  hover:scale-[1.02]
                  active:scale-[0.98]
                `}
              >
                {/* Glow effect */}
                <span className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/10 via-[#00FFD1]/5 to-[#00FFD1]/10 blur-sm pointer-events-none" />
                
                {/* Content */}
                <div className="relative z-10 flex items-center justify-between gap-2 md:gap-3">
                  <span className="truncate text-xs md:text-sm">
                    {(() => {
                      const activeItem = dynamicListResult.find(item => item.name === activeTab);
                      return activeItem ? activeItem.title : 'Select Version';
                    })()}
                  </span>
                  {/* Chevron Icon */}
                  <svg 
                    className={`w-3 h-3 md:w-4 md:h-4 transition-transform duration-300 flex-shrink-0 ${isDropdownOpen ? 'rotate-180' : ''}`}
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>

              {/* Dropdown Menu */}
              {isDropdownOpen && dynamicListResult.length > 0 && (
                <div className="absolute z-50 w-full mt-2 bg-black/95 backdrop-blur-sm border border-[#00FFD1]/30 rounded-lg shadow-xl overflow-hidden">
                  <div className="max-h-48 md:max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-[#00FFD1]/30 scrollbar-track-transparent">
                    {dynamicListResult.map((item, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          setActiveTab(item.name);
                          setIsDropdownOpen(false);
                        }}
                        className={`
                          w-full
                          px-3 md:px-4 
                          py-2 md:py-3 
                          text-left
                          font-medium 
                          text-xs md:text-sm
                          transition-all 
                          duration-200
                          border-b border-white/5 last:border-b-0
                          ${
                            activeTab === item.name
                              ? "bg-gradient-to-r from-[#00FFD1]/20 via-[#00FFD1]/10 to-transparent text-white border-l-2 border-[#00FFD1]"
                              : "text-gray-300 hover:bg-white/10 hover:text-white"
                          }
                        `}
                      >
                        <div className="flex items-center gap-2">
                          {activeTab === item.name && (
                            <div className="w-1 h-1 md:w-1.5 md:h-1.5 rounded-full bg-[#00FFD1] shadow-[0_0_6px_rgba(0,255,209,0.8)] flex-shrink-0" />
                          )}
                          <span className="truncate text-xs md:text-sm">{item.title}</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
          <>
            {listReferenceTemplate.map((item, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(item.name)}
                className={`
                  group
                  relative
                  px-4 
                  py-1.5 
                  mx-1
                  rounded-lg 
                  font-medium 
                  transition-all 
                  duration-300
                  overflow-hidden
                  touch-manipulation
                  select-none
                  focus-visible:outline-none
                  focus-visible:ring-2
                  focus-visible:ring-[#00FFD1]/50
                  focus-visible:ring-offset-2
                  focus-visible:ring-offset-transparent
                  ${
                    activeTab === item.name
                      ? "bg-gradient-to-r from-[#00FFD1]/20 via-[#00FFD1]/15 to-[#00FFD1]/20 text-white border border-[#00FFD1]/40 shadow-lg shadow-[#00FFD1]/10 scale-105"
                      : "bg-black/10 text-gray-400 border border-white/10 hover:bg-white/10 hover:border-white/20 hover:text-gray-300 hover:scale-105 active:scale-95"
                  }
                `}
              >
                {/* Active state glow effect */}
                {activeTab === item.name && (
                  <>
                    <span className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/10 via-[#00FFD1]/5 to-[#00FFD1]/10 blur-sm pointer-events-none" />
                    <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-shimmer pointer-events-none" />
                  </>
                )}
                
                {/* Hover ripple effect */}
                <span className="absolute inset-0 rounded-lg bg-white/0 active:bg-white/10 transition-colors duration-150 pointer-events-none" />
                
                {/* Content */}
                <span className="relative z-10">{item.title}</span>
              </button>
            ))}
          </>
          )}
          
          {/* Subtitle untuk menampilkan nama lengkap dari tab aktif */}
          {terimaHasilGen && idSession != "" && dynamicListResult.length > 0 && (
            <div className="px-1 md:px-2 pt-1 md:pt-2">
              {(() => {
                const activeItem = dynamicListResult.find(item => item.name === activeTab);
                if (!activeItem) return null;
                
                return (
                  <div className="relative group/subtitle">
                    {/* Background container dengan subtle glow */}
                    <div className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/5 via-transparent to-transparent rounded-lg opacity-0 group-hover/subtitle:opacity-100 transition-opacity duration-300" />
                    
                    {/* Content */}
                    <div className="relative flex items-center gap-2 md:gap-3 px-2 md:px-3 py-1.5 md:py-2 rounded-lg border border-transparent group-hover/subtitle:border-[#00FFD1]/20 transition-all duration-300">
                      {/* Icon indicator dengan glow effect */}
                      <div className="flex-shrink-0 relative">
                        <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#00FFD1] shadow-[0_0_8px_rgba(0,255,209,0.7)]" />
                        <div className="absolute inset-0 w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-[#00FFD1] animate-ping opacity-75" />
                      </div>
                      
                      {/* Title container */}
                      <div className="flex-1 min-w-0">
                        <p className="text-gray-300 text-xs md:text-sm font-semibold truncate transition-all duration-300 group-hover/subtitle:text-white group-hover/subtitle:drop-shadow-[0_0_8px_rgba(0,255,209,0.5)]">
                          {activeItem.title}
                        </p>
                        {/* Subtle gradient underline */}
                        <div className="h-[1px] bg-gradient-to-r from-[#00FFD1]/50 via-[#00FFD1]/30 to-transparent mt-0.5 md:mt-1 opacity-50 group-hover/subtitle:opacity-100 transition-opacity duration-300" />
                      </div>
                      
                      {/* Chevron indicator (optional) */}
                      <div className="flex-shrink-0 opacity-0 group-hover/subtitle:opacity-100 transition-opacity duration-300">
                        <svg 
                          className="w-3 h-3 md:w-4 md:h-4 text-[#00FFD1]" 
                          fill="none" 
                          viewBox="0 0 24 24" 
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>

        {/* CUSTOM REFERENCE UI */}
        {activeTab === 'custom' && !terimaHasilGen && idSession == "" ? (
          <div className="w-full space-y-6">
            {/* Notification Toast for Custom Reference */}

            
            {/* Upload Section */}
            <div className="space-y-3">
              <p className="text-gray-300 text-[16px] font-medium">Upload Custom Reference Video</p>
              <Dropzone
                onDrop={(acceptedFiles) => {
                  if (acceptedFiles.length > 0) {
                    const file = acceptedFiles[0];
                    setCustomVideoFile(file);
                    // Auto-set video name if empty
                    if (!customVideoName) {
                      setCustomVideoNameFix(file.name)
                      setCustomVideoName(file.name.replace(/\.[^/.]+$/, ""));
                    }
                  }
                }}
                accept={{
                  'video/mp4': ['.mp4'],
                  'video/webm': ['.webm'],
                  'video/quicktime': ['.mov'],
                }}
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div
                      {...getRootProps()}
                      className="
                        border border-white/10
                        rounded-2xl
                        h-[200px]
                        flex flex-col items-center justify-center
                        text-gray-300
                        text-[13px] 
                        backdrop-blur
                        hover:bg-white/5
                        transition-all
                        cursor-pointer
                        bg-black/10
                      "
                    >
                      <input {...getInputProps()} />
                      {customVideoFile ? (
                        <div className="text-center space-y-2">
                          <div className="text-2xl">✅</div>
                          <p className="opacity-80">{customVideoFile.name}</p>
                          <p className="text-xs opacity-60">Click to change file</p>
                        </div>
                      ) : (
                        <>
                          <div className="text-3xl mb-2 opacity-70">📤</div>
                          <p className="opacity-80">Click or drag to upload video</p>
                        </>
                      )}
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>

            {/* Video Name Input */}
            <div className="space-y-2">
              <label className="text-gray-300 text-[14px] font-medium">Video Name (No spaces allowed)</label>
              <input
                type="text"
                value={customVideoName}
                onChange={(e) => {
                  // Replace spaces with underscores
                  const valueWithoutSpaces = e.target.value.replace(/\s/g, '_');
                  setCustomVideoName(valueWithoutSpaces);
                }}
                placeholder="Enter video name (spaces will be replaced with _)"
                className="
                  w-full
                  px-4
                  py-2.5
                  rounded-lg
                  bg-black/20
                  border border-white/10
                  text-white
                  placeholder-gray-500
                  focus:outline-none
                  focus:ring-2
                  focus:ring-[#00FFD1]/50
                  focus:border-[#00FFD1]/40
                  transition-all
                  backdrop-blur
                "
              />
            </div>

            {/* Quota Check Toggle */}
            {/* <div className="flex items-center justify-between p-4 rounded-lg bg-black/10 border border-white/10">
              <div>
                <label className="text-gray-300 text-[14px] font-medium cursor-pointer">
                  Quota Check
                </label>
                <p className="text-gray-500 text-xs mt-1">Enable quota verification</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={quotaCheck}
                  onChange={(e) => setQuotaCheck(e.target.checked)}
                  className="sr-only peer"
                />
                <div className="
                  w-11
                  h-6
                  bg-gray-600
                  peer-focus:outline-none
                  peer-focus:ring-2
                  peer-focus:ring-[#00FFD1]/50
                  rounded-full
                  peer
                  peer-checked:after:translate-x-full
                  peer-checked:after:border-white
                  after:content-['']
                  after:absolute
                  after:top-[2px]
                  after:left-[2px]
                  after:bg-white
                  after:rounded-full
                  after:h-5
                  after:w-5
                  after:transition-all
                  peer-checked:bg-[#00FFD1]
                "></div>
              </label>
            </div> */}

            {/* Upload Button */}
            <div className="space-y-3">
              <button
                onClick={() => {
                  if (customVideoFile && customVideoName && !uploadingLoading) {
                    uploadCustomReference();
                  }
                }}
                disabled={!customVideoFile || !customVideoName || uploadingLoading || showProgress}
                className={`
                  w-full
                  px-4
                  py-2.5
                  rounded-lg
                  font-medium
                  transition-all
                  duration-200
                  border
                  flex
                  items-center
                  justify-center
                  gap-2
                  ${
                    uploadingLoading
                      ? 'bg-[#044250] text-white border-[#00FFD1] cursor-wait opacity-90'
                      : customVideoFile && customVideoName
                      ? 'bg-[#044250] hover:bg-[#03333d] text-white border-[#00FFD1] cursor-pointer hover:scale-[1.02] active:scale-[0.98]'
                      : 'bg-black/20 text-gray-500 border-white/10 cursor-not-allowed opacity-50'
                  }
                `}
              >
                {uploadingLoading ? (
                  <UploadLoadingSpinner />
                ) : (
                  <>
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-5 w-5" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" 
                      />
                    </svg>
                    Upload Custom Reference
                  </>
                )}
              </button>

              {/* Upload Progress Display */}
              {showProgress && (uploadStatus || uploadProgress > 0) && (
                <div 
                  className={`
                    w-full
                    px-4
                    py-3
                    rounded-lg
                    bg-gradient-to-r from-[#00FFD1]/10 via-[#00FFD1]/5 to-[#00FFD1]/10
                    border border-[#00FFD1]/30
                    backdrop-blur-sm
                    transition-all
                    duration-500
                    ${
                      showProgress 
                        ? 'opacity-100 translate-y-0' 
                        : 'opacity-0 -translate-y-2 pointer-events-none'
                    }
                  `}
                  style={{
                    animation: showProgress ? 'slideDownFade 0.3s ease-out' : 'fadeOut 0.3s ease-out'
                  }}
                >
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-3 flex-1">
                      {/* Animated Spinner */}
                      <div className="relative">
                        <svg 
                          className="animate-spin h-5 w-5 text-[#00FFD1]" 
                          xmlns="http://www.w3.org/2000/svg" 
                          fill="none" 
                          viewBox="0 0 24 24"
                        >
                          <circle 
                            className="opacity-25" 
                            cx="12" 
                            cy="12" 
                            r="10" 
                            stroke="currentColor" 
                            strokeWidth="4"
                          ></circle>
                          <path 
                            className="opacity-75" 
                            fill="currentColor" 
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        <div className="absolute inset-0 animate-ping">
                          <div className="h-5 w-5 rounded-full bg-[#00FFD1] opacity-20"></div>
                        </div>
                      </div>

                      {/* Status and Percentage */}
                      <div className="flex-1">
                        <p className="text-sm font-medium text-white">
                          {uploadStatus && uploadProgress !== undefined 
                            ? `${uploadStatus} - ${uploadProgress}%`
                            : uploadStatus 
                            ? uploadStatus
                            : `${uploadProgress}%`
                          }
                        </p>
                        
                        {/* Progress Bar */}
                        <div className="mt-2 w-full bg-black/20 rounded-full h-1.5 overflow-hidden">
                          <div 
                            className="h-full bg-gradient-to-r from-[#00FFD1] to-[#00AEEF] rounded-full transition-all duration-300 ease-out"
                            style={{ 
                              width: `${uploadProgress}%`,
                              boxShadow: '0 0 10px rgba(0, 255, 209, 0.5)'
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>

                    {/* Percentage Badge */}
                    {uploadProgress > 0 && (
                      <div className="px-3 py-1 rounded-full bg-[#00FFD1]/20 border border-[#00FFD1]/40 text-[#00FFD1] text-xs font-semibold min-w-[50px] text-center">
                        {uploadProgress}%
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Notification Toast - positioned right below the button */}
            </div>

            {notification.show && (
              <div className={`w-full px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm border transition-all duration-300 transform ${
                notification.type === 'success' 
                  ? 'bg-green-500/90 border-green-400 text-white' 
                  : 'bg-red-500/90 border-red-400 text-white'
              }`}
              style={{
                animation: 'slideDownFade 0.3s ease-out'
              }}>
                <div className="flex items-center gap-2">
                  {notification.type === 'success' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  )}
                  <p className="text-sm font-medium">{notification.message}</p>
                </div>
              </div>
            )}

            {/* Custom References List */}
            {customReferencesList.length > 0 && (
              <div className="space-y-4 mt-8">
                <p className="text-gray-300 text-[16px] font-medium">Custom References</p>
                
                {/* Video Preview Space */}
                <div className="bg-black/20 rounded-2xl p-6 border border-white/10 backdrop-blur shadow-inner">
                  {loading && !customRefVideoUrl ? (
                    <div className="flex items-center justify-center h-[300px]">
                      <div className="text-center space-y-3">
                        <svg 
                          className="animate-spin h-8 w-8 text-[#00FFD1] mx-auto" 
                          xmlns="http://www.w3.org/2000/svg" 
                          fill="none" 
                          viewBox="0 0 24 24"
                        >
                          <circle 
                            className="opacity-25" 
                            cx="12" 
                            cy="12" 
                            r="10" 
                            stroke="currentColor" 
                            strokeWidth="4"
                          ></circle>
                          <path 
                            className="opacity-75" 
                            fill="currentColor" 
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        <p className="text-gray-400 text-sm">Loading video...</p>
                      </div>
                    </div>
                  ) : customRefVideoUrl ? (
                    <video
                      className="rounded-xl shadow-lg w-full max-w-[520px] mx-auto"
                      controls
                      src={customRefVideoUrl}
                      preload="metadata"
                      playsInline
                      poster={customRefVideoThumbnail || undefined}
                    />
                  ) : (
                    <div className="flex items-center justify-center h-[300px] text-gray-500">
                      <div className="text-center space-y-2">
                        <svg 
                          xmlns="http://www.w3.org/2000/svg" 
                          className="h-12 w-12 mx-auto opacity-50" 
                          fill="none" 
                          viewBox="0 0 24 24" 
                          stroke="currentColor"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" 
                          />
                        </svg>
                        <p className="text-sm">Select a custom reference to preview</p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Custom References Buttons List */}
                <div className="flex flex-wrap gap-3">
                  {customReferencesList.map((refName, index) => (
                    <div
                      key={index}
                      className={`
                        group
                        relative
                        flex
                        items-center
                        gap-2
                        px-4
                        py-2
                        rounded-lg
                        font-medium
                        text-sm
                        transition-all
                        duration-200
                        border
                        ${
                          deletingRef === refName
                            ? 'opacity-50 pointer-events-none'
                            : selectedCustomRef === refName
                            ? 'bg-gradient-to-r from-[#00FFD1]/20 via-[#00FFD1]/15 to-[#00FFD1]/20 text-white border-[#00FFD1]/40 shadow-lg shadow-[#00FFD1]/10 scale-105'
                            : 'bg-black/10 text-gray-400 border-white/10 hover:bg-white/10 hover:border-white/20 hover:text-gray-300 hover:scale-105'
                        }
                        ${deletingRef === refName ? 'animate-pulse' : ''}
                      `}
                    >
                      {/* Active state glow effect */}
                      {selectedCustomRef === refName && (
                        <span className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/10 via-[#00FFD1]/5 to-[#00FFD1]/10 blur-sm pointer-events-none rounded-lg" />
                      )}
                      
                      {/* Hover ripple effect */}
                      <span className="absolute inset-0 rounded-lg bg-white/0 active:bg-white/10 transition-colors duration-150 pointer-events-none" />
                      
                      {/* Select Button */}
                      <button
                        onClick={() => {
                          if (deletingRef !== refName) {
                            getCustomRefVideo(refName);
                            setPilih(refName);
                          }
                        }}
                        disabled={deletingRef === refName}
                        className="relative z-10 flex-1 text-left capitalize hover:text-white transition-colors"
                      >
                        {deletingRef === refName ? (
                          <span className="flex items-center gap-2">
                            <svg 
                              className="animate-spin h-4 w-4" 
                              xmlns="http://www.w3.org/2000/svg" 
                              fill="none" 
                              viewBox="0 0 24 24"
                            >
                              <circle 
                                className="opacity-25" 
                                cx="12" 
                                cy="12" 
                                r="10" 
                                stroke="currentColor" 
                                strokeWidth="4"
                              ></circle>
                              <path 
                                className="opacity-75" 
                                fill="currentColor" 
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Deleting...
                          </span>
                        ) : (
                          refName.replace(/_/g, ' ')
                        )}
                      </button>

                      {/* Delete Button */}
                      {!deletingRef && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowDeleteConfirm(showDeleteConfirm === refName ? null : refName);
                          }}
                          className={`
                            relative
                            z-10
                            p-1.5
                            rounded-md
                            transition-all
                            duration-200
                            ${
                              showDeleteConfirm === refName
                                ? 'bg-red-500/20 text-red-400 border border-red-500/40'
                                : 'text-gray-500 hover:text-red-400 hover:bg-red-500/10'
                            }
                            group/delete
                          `}
                          title="Delete reference"
                        >
                          {showDeleteConfirm === refName ? (
                            <svg 
                              xmlns="http://www.w3.org/2000/svg" 
                              className="h-4 w-4" 
                              fill="none" 
                              viewBox="0 0 24 24" 
                              stroke="currentColor"
                            >
                              <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={2} 
                                d="M6 18L18 6M6 6l12 12" 
                              />
                            </svg>
                          ) : (
                            <svg 
                              xmlns="http://www.w3.org/2000/svg" 
                              className="h-4 w-4 group-hover/delete:scale-110 transition-transform" 
                              fill="none" 
                              viewBox="0 0 24 24" 
                              stroke="currentColor"
                            >
                              <path 
                                strokeLinecap="round" 
                                strokeLinejoin="round" 
                                strokeWidth={2} 
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" 
                              />
                            </svg>
                          )}
                        </button>
                      )}

                      {/* Confirmation Dialog */}
                      {showDeleteConfirm === refName && (
                        <div className="delete-confirm-container absolute top-full left-0 mt-2 z-50 bg-black/95 backdrop-blur-sm border border-red-500/40 rounded-lg p-3 shadow-xl min-w-[200px]">
                          <p className="text-sm text-white mb-3">Delete this reference?</p>
                          <div className="flex gap-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteCustomReference(refName);
                              }}
                              className="flex-1 px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs rounded-md transition-colors font-medium"
                            >
                              Delete
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteConfirm(null);
                              }}
                              className="flex-1 px-3 py-1.5 bg-gray-600 hover:bg-gray-700 text-white text-xs rounded-md transition-colors font-medium"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {!terimaHasilGen && activeTab !== 'custom' && idSession == "" && (
              <video
                className="rounded-xl shadow-lg w-[520px]"
                controls
                src={activeVideo.src}
                // src={"https://webserver.infidea.dev/kerafactor.mp4"}
                preload="metadata"
                playsInline
                poster={activeVideoThumbnail || undefined}
              />
            )}
        
            {terimaHasilGen && idSession != "" && (
              <>
                {loading ? (
                  <>
                    <p className="modal-text">Loading your amazing video<AnimatedDots /> </p>
                  </>
                ) : (
                  <>
                    <video
                      ref={videoRef}
                      className="rounded-xl shadow-lg w-[520px]"
                      controls
                      src={videoUrl}
                      preload="metadata"
                      playsInline
                      poster={videoThumbnail || undefined}
                    />
                  </>
                )}
              </>
            )}

            {!terimaHasilGen && activeTab !== 'custom' && idSession == "" ? (
              <>
                <p className="text-gray-300 text-[16px]">
                  Pick as Reference:
                </p>
                <button className="bg-black/10 text-gray-400 border border-white/10 hover:bg-white/5 px-4 py-1.5 rounded-lg font-medium transition-all" style={{margin: '0px'}} onClick={() => {setPilih(activeVideo.label)}}>
                  {activeVideo.label}
                </button>
              </>
            ) : (
              <>
                {!loading && terimaHasilGen && idSession != "" && (
                  <button className="w-[160px] justify-center bg-[#044250] hover:bg-[#03333d] text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium transition-colors duration-200" style={{border: "1px solid #00FFD1"}} onClick={handleDownload}>
                    Download Video
                  </button>
                )}
              </>
            )}
          </>
        )}

      </div>

      {!terimaHasilGen && activeTab !== 'custom' && idSession == "" && (
        
        <>
          {/* THUMBNAIL CAROUSEL */}
          <div className="relative w-full">
            <div className="md:mx-8 overflow-x-auto scrollbar-hide">
              <div className="flex flex-wrap gap-4 justify-center min-w-full md:px-4">
                {currentVideos.map((item, index) => (
                  <Thumbnail
                    key={index}
                    {...item}
                    active={activeVideo.src === item.src}
                    onClick={() => setActiveVideo(item)}
                  />
                ))}
              </div>
            </div>
          </div>
        </>
      )}

    {terimaHasilGen && !loading && idSession != "" && (
    <div className="p-1 text-white rounded-lg shadow-md overflow-x-auto">
      {/* Copy Button */}
      <div className="mb-3 flex justify-end relative">
        <button
          onClick={copyTableToClipboard}
          className="bg-[#044250] hover:bg-[#03333d] text-white px-4 py-2 rounded-lg flex items-center gap-2 font-medium transition-colors duration-200 text-sm"
          style={{border: "1px solid #00FFD1"}}
          title="Copy in Excel"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          Copy in Excel
        </button>
        
        {/* Notification Toast */}
        {notification.show && (
          <div className={`absolute top-12 right-0 z-50 px-4 py-3 rounded-lg shadow-lg backdrop-blur-sm border transition-all duration-300 transform ${
            notification.type === 'success' 
              ? 'bg-green-500/90 border-green-400 text-white' 
              : 'bg-red-500/90 border-red-400 text-white'
          }`}
          style={{
            maxWidth: '320px',
            wordWrap: 'break-word',
            animation: 'slideDownFade 0.3s ease-out'
          }}>
            <div className="flex items-center gap-2">
              {notification.type === 'success' ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )}
              <p className="text-sm font-medium">{notification.message}</p>
            </div>
          </div>
        )}
      </div>
      {/* Tabel dengan border penuh */}
      <table className="min-w-full border-collapse border border-gray-600">
        <thead>
          <tr className="bg-black/60">
            <th className="border border-gray-600 px-4 py-2 font-semibold text-left">No</th>
            <th className="border border-gray-600 px-4 py-2 font-semibold text-left">Start</th>
            <th className="border border-gray-600 px-4 py-2 font-semibold text-left">End</th>
            <th className="border border-gray-600 px-4 py-2 font-semibold text-left">Reasoning</th>
          </tr>
        </thead>
        <tbody>
          {historye.map((clip, index) => (
            <tr
              key={index}
              className={`hover:bg-black/20  transition-colors ${
                index % 2 === 0 ? 'bg-black/10' : 'bg-black/60'
              }`}
              onClick={() => {goToSecond(clip.target_start_time)}}
              style={{cursor: "pointer"}}
            >
              <td className="border border-gray-600 px-4 py-2">{index+1}</td>
              <td className="border border-gray-600 px-4 py-2">{clip.target_start_time}</td>
              <td className="border border-gray-600 px-4 py-2">{clip.target_end_time}</td>
              <td className="border border-gray-600 px-4 py-2 max-w-xs md:max-w-md lg:max-w-lg whitespace-normal break-words">
                {clip.description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    )}


    </div>
  );
}

/* THUMBNAIL */
function Thumbnail({ src, label, active, onClick }) {
  const [thumbnail, setThumbnail] = useState(null);
  const [isLoadingThumbnail, setIsLoadingThumbnail] = useState(false);

  // Fungsi untuk generate thumbnail dari video URL
  useEffect(() => {
    if (!src) {
      setThumbnail(null);
      setIsLoadingThumbnail(false);
      return;
    }

    setIsLoadingThumbnail(true);
    setThumbnail(null);

    const generateThumbnail = () => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");
      
      video.src = src;
      video.muted = true; // iOS often blocks autoplay/loading if not muted
      video.playsInline = true; // Crucial for background loading on iOS
      video.crossOrigin = "anonymous";
      video.currentTime = 0.1; // Seek to the first frame

      const captureFrame = () => {
        try {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          
          // Set the generated image as thumbnail
          const thumbnailData = canvas.toDataURL("image/jpeg");
          
          // Cleanup
          video.remove();
          canvas.remove();
          
          setThumbnail(thumbnailData);
          setIsLoadingThumbnail(false);
        } catch (error) {
          console.error('Error generating thumbnail:', error);
          // Cleanup on error
          video.remove();
          canvas.remove();
          setThumbnail(null);
          setIsLoadingThumbnail(false);
        }
      };

      const handleError = () => {
        console.error('Error loading video for thumbnail');
        video.remove();
        canvas.remove();
        setThumbnail(null);
        setIsLoadingThumbnail(false);
      };

      // Wait for the seek to complete before capturing
      video.addEventListener("seeked", captureFrame, { once: true });
      video.addEventListener("error", handleError, { once: true });
      
      // Trigger the load
      video.load();
    };

    generateThumbnail();
  }, [src]);

  return (
    <div
      onClick={onClick}
      className={`relative w-[96px] aspect-square rounded-xl overflow-hidden
        bg-black/20 backdrop-blur border cursor-pointer group
        ${
          active
            ? "border-[#00AEEF] shadow-[0_0_12px_rgba(0,174,239,0.55)]"
            : "border-white/10"
        }
        transition-all hover:scale-[1.05]`}
    >
      <video
        src={src}
        muted
        preload="metadata"
        playsInline
        className="w-full h-full object-cover"
        poster={thumbnail || undefined}
      />

      {/* LOADING INDICATOR */}
      {isLoadingThumbnail && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-10">
          <div className="relative">
            <svg 
              className="animate-spin h-6 w-6 text-[#00AEEF]" 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24"
            >
              <circle 
                className="opacity-25" 
                cx="12" 
                cy="12" 
                r="10" 
                stroke="currentColor" 
                strokeWidth="4"
              ></circle>
              <path 
                className="opacity-75" 
                fill="currentColor" 
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>
        </div>
      )}

      {/* HOVER TITLE */}
      <div
        className="absolute inset-0 flex items-end justify-center
        bg-gradient-to-t from-black/70 via-black/20 to-transparent
        opacity-0 group-hover:opacity-100 transition-opacity duration-300
        pointer-events-none"
      >
        <span className="text-xs text-white mb-2 capitalize">{label}</span>
      </div>
    </div>
  );
}
